import { Component, OnInit } from '@angular/core';
import { Uo } from '../../models/uo'
import { MessageService } from 'primeng/api';
import {ConfirmationService} from 'primeng/api';
import { NormaService } from '../../services/norma.service'
import { CrudsService } from '../../services/cruds.service'

@Component({
  selector: 'app-uo',
  templateUrl: './uo.component.html',
  styleUrls: ['./uo.component.scss']
})
export class UoComponent implements OnInit {

  caso_uso: string = 'new'
  btn_aceptar_lbl: string = ''
  btn_aceptar_style: string = ''
  mensaje_eliminacion: string = '¿Confirma la elminación de esta Unidad Organizativa?'

  id_uo: string = ''
  it_descripcion: string = ''
  it_descripcion_disabled: boolean = false
  it_descripcion_corta: string = ''
  it_descripcion_corta_disabled: boolean = false
  it_buscar: string = ''

  tbl_columnas = []
  tbl_uo: Uo[] = []
  tbl_uo_selected: Uo = null
  tbl_totalRecords: number = 0
  tbl_paginatorPosition: string = "bottom"
  tbl_loading: boolean = false;

  constructor(
    private normaService: NormaService,
    private messageService: MessageService,
    private crudsService: CrudsService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {

    this.tbl_loading = true

    this.tbl_columnas = [
      { field: 'descripcion', header: 'Descripción' },
      { field: 'descripcion_corta', header: 'Abreviatura' }
    ]

    this.clear_components()
    this.load_data()
  }

  cancelar() {
    this.clear_components()
  }

  aceptar() {

    let datos_ok: boolean = true

    if (this.it_descripcion == '') {
      // Si el usuario no escribe en descripcion

      this.messageService.add({severity:'warn', summary:'', detail:'Debe indicar la descripción de la Unidad Organizativa'})
      datos_ok = false
    }

    if (this.it_descripcion_corta == '') {
      // Si el usuario no escribe en descripcion

      this.messageService.add({severity:'warn', summary:'', detail:'Debe indicar la abreviatura de la Unidad Organizativa'})
      datos_ok = false
    }

    if (datos_ok) {
      // Si datos ok

      let object: any = {}
      let caso_uso_mensaje: string

      if (this.caso_uso == 'new') {
        object['descripcion'] = this.it_descripcion
        object['descripcion_corta'] = this.it_descripcion_corta
        caso_uso_mensaje = 'agregada'
        this.guardar(object, caso_uso_mensaje)
      } else if (this.caso_uso == 'edit') {
        object['id'] = this.id_uo
        object['descripcion'] = this.it_descripcion
        object['descripcion_corta'] = this.it_descripcion_corta
        caso_uso_mensaje = 'actualizada'
        this.guardar(object, caso_uso_mensaje)
      } else if (this.caso_uso == 'delete') {
        this.confirmationService.confirm({
          header: "Atención!",
          message: this.mensaje_eliminacion,
          acceptLabel: 'Sí',
          rejectLabel: 'No',
          accept: () => {
            object['id'] = this.id_uo
            caso_uso_mensaje = 'eliminada'
            this.guardar(object, caso_uso_mensaje)
          }
        })
      }
    }
  }

  guardar(par_object, par_caso_uso_mensaje) {

    this.crudsService.uo(this.caso_uso, par_object).subscribe(data => {

      if (data['code'] != undefined) {
        // Si se guardo ok

        this.messageService.add({severity:'success', summary:'', detail: 'Unidad Organizativa ' + par_caso_uso_mensaje})
        this.clear_components()
        this.load_data(this.it_buscar)
      } else {
        // Si no se guardo ok

        if (data['error_code'] != undefined) {
          if (data['message_code'] == 'err-uo-already-exist') {
            this.messageService.add({severity:'warn', summary:'', detail: 'Ya se ha registrado esta Unidad Organizativa'})
          } else {
            this.messageService.add({severity:'warn', summary:'', detail: data['error_code'] + ' - ' + data['error_description'] + ' - ' + data['message_code'] + ' - ' + data['message_description']})
          }
        }
      }
    })
  }

  load_data(par_buscar?: string) {

    this.normaService.getUO(null, par_buscar).subscribe(data => {

      let list = data['data']
      this.tbl_totalRecords = list.length
      this.tbl_uo = list
      this.tbl_loading = false
    })
  }

  clear_components() {

    this.caso_uso = 'new'
    this.id_uo = ''
    this.it_descripcion = ''
    this.it_descripcion_disabled = false
    this.it_descripcion_corta = ''
    this.it_descripcion_corta_disabled = false
    this.btn_aceptar_lbl = 'Agregar'
    this.btn_aceptar_style = 'ui-button-primary'
  }

  edit_row(par_rowData) {

    this.caso_uso = 'edit'
    this.btn_aceptar_lbl = 'Actualizar'
    this.btn_aceptar_style = 'ui-button-primary'
    this.id_uo = par_rowData.id
    this.it_descripcion = par_rowData.descripcion
    this.it_descripcion_disabled = false
    this.it_descripcion_corta = par_rowData.descripcion_corta
    this.it_descripcion_corta_disabled = false
  }

  delete_row(par_rowData) {

    this.caso_uso = 'delete'
    this.btn_aceptar_lbl = 'Eliminar'
    this.btn_aceptar_style = 'ui-button-danger'
    this.id_uo = par_rowData.id
    this.it_descripcion = par_rowData.descripcion
    this.it_descripcion_disabled = true
    this.it_descripcion_corta = par_rowData.descripcion_corta
    this.it_descripcion_corta_disabled = true
  }

  buscar() {

    this.load_data(this.it_buscar)
  }

  estilo_columnas(par_tipo: string, par_columna: string) {
    let estilo : string = ''

    if (par_columna == 'descripcion') {
      estilo = par_tipo == 'head' ? 'descripcion_head_style' : 'descripcion_style'
    } else if (par_columna == 'descripcion_corta') {
      estilo = par_tipo == 'head' ? 'descripcion_corta_head_style' : 'descripcion_corta_style'
    }
    return estilo
  }
}
